import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Popup from '../../../components/Popup'
import { closeShipmentItemsCreatePopup, createShipmentItem, selectShipmentItemsCreatePopup, setShipmentItemsCreatePopupData } from '../ShipmentItems/shipmentItemsSlice'
import { Button } from '@mui/material'

import style from "../../../sass/components/popups/shipment-item-popup.module.scss"
import { selectShipment } from '../shipmentSlice'
import SelectProductType from '../../productTypeSelect/SelectProductType'
import { STANDARD_PACKAGE_TYPE, countryCodes } from '../../../data/static-data'
import { validateEnName, validateGtipCode, validateItemsCount, validateMarketLink, validatePrice, validateOriginalName, validateShipmentItem, validateTrName } from '../../../validators/validateShipmentItem'
import { pushAlert } from '../../alerts/alertSlice'
import { useTranslation } from 'react-i18next'


const initialState = {
    "en-name": "",
    "tr-name": "",
    "original-name": "",
    "gtip-code": "",
    "item-code": "11111",
    "link": "",
    "value-for-one": "",
    "count": 1,
    "warning": false,
    "country-code": countryCodes[0].value ?? "TR",
}

const initialErrorState = {
    "tr-name": "",
    "original-name": "",
    "en-name": "",
    "gtip-code": "",
    link: "",
    "value-for-one": "",
    count: "",
    warning: "",
    "country-code": "",
}

const CreateShipmentItemPopup = () => {
    const {t} = useTranslation()
    const dispatch = useDispatch()
    //popup data from redux state (opened, data)
    const popupState = useSelector(selectShipmentItemsCreatePopup)
    const shipment = useSelector(selectShipment)


    const [state, setState] = useState({...initialState});
    const [errors, setErrors] = useState({...initialErrorState});
    const [productType, setProductType] = useState(null)

    //setting state functions
    const setTrName = (value) => {
        setState((prev) => ({ ...prev, "tr-name": value }));
        let validationResult = validateTrName(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "tr-name": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "tr-name": "",
            }));
        }
    };
    const setEnName = (value) => {
        setState((prev) => ({ ...prev, "en-name": value }));
        let validationResult = validateEnName(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "en-name": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "en-name": "",
            }));
        }
    };
    const setOriginalName = (value) => {
        setState((prev) => ({ ...prev, "original-name": value }));
        let validationResult = validateOriginalName(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "original-name": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "original-name": "",
            }));
        }
    };
    const setGtipCode = (value) => {
        setState((prev) => ({ ...prev, "gtip-code": value }));
        
        let validationResult = validateGtipCode(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "gtip-code": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "gtip-code": "",
            }));
        }
    };

    const setLink = (value) => {
        setState((prev) => ({ ...prev, "link": value }));
        let validationResult = validateMarketLink(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "link": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "link": "",
            }));
        }
    };
    const setValueForOne = (value) => {
        value = value.replace(",", ".");
        setState((prev) => ({ ...prev, "value-for-one": value }));
        let validationResult = validatePrice(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "value-for-one": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "value-for-one": "",
            }));
        }
    };
    const setCount = (value) => {
        setState((prev) => ({ ...prev, "count": value }));
        let validationResult = validateItemsCount(value);
        if (validationResult != null) {
            setErrors((prev) => ({
                ...prev,
                "count": t(validationResult),
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                "count": "",
            }));
        }
    };
    const setCountryCode = (value) => {
        setState((prev) => ({ ...prev, "country-code": value }));
    };

    //on changing popup data in redux state 
    //(for example closing popup after creating shipment)
    useEffect(() => {
        setErrors({...initialErrorState})
        if(!popupState.data) {
            setState({...initialState})
            return
        }

        setState({...popupState.data})
    }, [popupState.data])

    useEffect(() => {
        if(!productType) {
            return
        }
        setState((prev) => ({...prev, ...productType}))
    },  [productType])

    const closePopup = () => {
        setProductType(null)
        dispatch(closeShipmentItemsCreatePopup())
    }

    const handleButtonClick = () => {
        console.log("in button handler")
        if(!shipment.id || !popupState.boxID) {
            return
        }
        console.log(state)

        let errors = validateShipmentItem(state)
        if(errors && errors.length > 0) {
            errors.forEach((error) => {
                dispatch(pushAlert({
                    type: "danger",
                    message: t(error),
                    delay: 2000
                }))
            })
            return
        }

        setProductType("")
        dispatch(setShipmentItemsCreatePopupData({
            data: state
        }))
        dispatch(createShipmentItem({
            shipmentID: shipment.id,
            boxID: popupState.boxID,
            data: state,
        }))
    }

    return (
        <Popup opened={popupState.opened} closeCallback={closePopup}>
        <header className="text-xl text-emerald-600 text-left mb-3">
                {t("shipment.items.item_popup.create_title")}
        </header>

        <form className="flex flex-col gap-4 mb-4 text-left">

            {/* MARKET LINK */}
            {shipment && shipment["package-type"] === STANDARD_PACKAGE_TYPE && (
                <div className="flex flex-col gap items-start">
                    <span className="text-xs text-gray-600">
                            {t("shipment.items.item_popup.link.title")}
                    </span>
                    <input
                        className={style.input}
                        placeholder={t("shipment.items.item_popup.link.placeholder")}
                        value={state["link"]}
                        onInput={(e) => setLink(e.target.value)}
                        type="text"
                    />
                    {errors["link"] && (
                        <div className={style.error}>{errors["link"]}</div>
                    )}
                </div>
            )}
            <div className="flex flex-col gap items-start">
                <span className="text-xs text-gray-600">
                    {t("shipment.items.item_popup.original_name.title")}
                </span>
                <input
                    className={style.input}
                    placeholder={t("shipment.items.item_popup.original_name.placeholder")}
                    value={state["original-name"]}
                    onInput={(e) => setOriginalName(e.target.value)}
                    type="text"
                />
                {errors["original-name"] && (
                    <div className={style.error}>{errors["original-name"]}</div>
                )}
            </div>
            <div className="flex flex-col gap items-start">
                <span className="text-xs text-gray-600">
                    {t("shipment.items.item_popup.value_for_one.title")}
                </span>
                <input
                    className={style.input}
                    placeholder={t("shipment.items.item_popup.value_for_one.placeholder")}
                    value={state["value-for-one"]}
                    onInput={(e) => setValueForOne(e.target.value)}
                    type="text"
                />
                {errors["value-for-one"] && (
                    <div className={style.error}>
                        {errors["value-for-one"]}
                    </div>
                )}
            </div>
            <div className="flex flex-col gap items-start">
                <span className="text-xs text-gray-600">
                    {t("shipment.items.item_popup.count.title")}
                </span>
                <input
                    className="border text-2xs px-2 w-28"
                    placeholder={t("shipment.items.item_popup.count.placeholder")}
                    value={state["count"]}
                    onInput={(e) => setCount(e.target.value)}
                    type="number"
                />
                {errors["count"] && (
                    <div className={style.error}>{errors["count"]}</div>
                )}
            </div>
            <div className="flex flex-col gap items-start">
                <span className="text-xs text-gray-600">
                    {t("shipment.items.item_popup.origin_country.title")}
                </span>
                <select
                    className={`${style.select}`}
                    value={state["country-code"]}
                    onChange={(e) => setCountryCode(e.target.value)}
                >
                    {countryCodes.map((country, index) => (
                        <option key={index} value={country.value}>
                            {country.text}
                        </option>
                    ))}
                </select>
            </div>
            <div className="flex flex-col gap items-start">
                <div className="flex justify-start items-center gap-2">
                    <span className="text-xs text-gray-600">
                        {t("shipment.items.item_popup.warning.title")}
                    </span>
                    <input
                        className={`${style.checkbox} h-4 w-4`}
                        type="checkbox"
                        checked={state.warning}
                        onChange={e => setState(prev => ({...prev, warning: !state.warning}))}
                    />
                </div>
            </div>
            <SelectProductType setState={setProductType} state={productType}/>
            <div className="flex flex-col gap items-start">
                <span className="text-xs text-gray-600">
                    {t("shipment.items.item_popup.tr_name.title")}
                </span>
                <input
                    className={style.input}
                    placeholder={t("shipment.items.item_popup.tr_name.placeholder")}
                    value={state["tr-name"]}
                    onInput={(e) => setTrName(e.target.value)}
                    type="text"
                />
                {errors["tr-name"] && (
                    <div className={style.error}>{errors["tr-name"]}</div>
                )}
            </div>
            <div className="flex flex-col gap items-start">
                <span className="text-xs text-gray-600">{t("shipment.items.item_popup.en_name.title")}</span>
                <input
                    className={style.input}
                    placeholder={t("shipment.items.item_popup.en_name.placeholder")}
                    value={state["en-name"]}
                    onInput={(e) => setEnName(e.target.value)}
                    type="text"
                />
                {errors["en-name"] && (
                    <div className={style.error}>{errors["en-name"]}</div>
                )}
            </div>
            <div className="flex flex-col gap items-start">
                <span className="text-xs text-gray-600">
                    {t("shipment.items.item_popup.gtip_code.title")}
                </span>
                <input
                    className={style.input}
                    placeholder={t("shipment.items.item_popup.gtip_code.placeholder")}
                    value={state["gtip-code"]}
                    onInput={(e) => setGtipCode(e.target.value)}
                    type="text"
                />
                {errors["gtip-code"] && (
                    <div className={style.error}>{errors["gtip-code"]}</div>
                )}
            </div>

            
                
        </form>

        <Button
            variant="contained"
            sx={{
                color: "white",
                bgcolor: "#059669",
                fontSize: "0.7rem",
                ":hover": {
                    bgcolor: "#047857",
                },
                ":focus": {
                    bgcolor: "#047857",
                },
            }}
            className="w-10/12"
            onClick={handleButtonClick}
        >
        {t("shipment.items.item_popup.create_button")}
        </Button>
        </Popup>
    )
}

export default CreateShipmentItemPopup